import * as React from 'react'
import {
  RoadmapSectionContainer,
  RoadmapSectionHeader,
  RoadmapSectionHeaderTitle,
  RoadmapSectionRow, StyledButton,
  RoadmapSectionButtonWrapper,
  RoadmapItemWrapper,
  RoadmapItemTitle,
  RoadmapItemSubtitle,
  RoadmapSectionImage,
  StyledLi,
  ListDots,
  ListDotsProgress,
  ListDotsWrapper,
  ListDotsClear,
  ListDotsItem,
  Dot,
  ListDotsItemContent,
  ListDotsItemTitle, ShieldWhiteIcon
} from './RoadmapSection.elements'
import {MouseEvent} from "react";
import {
  CertificateIcon,
  DocumentCheckIcon,
  ShieldIcon, WhiteGenericFormIcon
} from "@components/Icons";
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import Analytics from "@lib/Analytics";
import {compileAnalyticsEventProps} from "@lib/analytics-event-props";

export type RoadmapSectionProps = {
  title: string
  imageUrl: string
  data: any[]
  mobileData: any[]
}

export type RoadmapItemProps = {
  title: string
  subtitle: string
}

export const RoadmapItem: React.FunctionComponent<RoadmapItemProps> = ({ title, subtitle}) => {

  return (
    <RoadmapItemWrapper>
      <RoadmapItemTitle dangerouslySetInnerHTML={{ __html: title }} />
      <RoadmapItemSubtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
    </RoadmapItemWrapper>
  );
}

export const getDotIcon = (type: string) => {
  if (type === 'shield'){
    return <ShieldIcon css={ShieldWhiteIcon} />
  }
  if (type === 'certificate'){
    return <CertificateIcon />
  }
  if (type === 'document-check'){
    return <DocumentCheckIcon />
  }
  if (type === 'generic-form'){
    return <WhiteGenericFormIcon />
  }
}

export const RoadmapSection: React.FunctionComponent<RoadmapSectionProps> = ({title, data, imageUrl, mobileData}) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    Analytics.log('Click', compileAnalyticsEventProps({ location: 'roadmap-section' }))

    setTimeout(() => {
      window.location.href = '/signup'
    }, 500)
  }

  return (
    <RoadmapSectionContainer>
      <RoadmapSectionHeader>
        <RoadmapSectionHeaderTitle dangerouslySetInnerHTML={{__html: title}}/>
      </RoadmapSectionHeader>
      <RoadmapSectionImage imageUrl={imageUrl} />
      <RoadmapSectionRow>
        {data.map(d => (
          <StyledLi key={d.title}>
            <RoadmapItem
              title={d.title}
              subtitle={d.subtitle}
            />
          </StyledLi>
        ))}
      </RoadmapSectionRow>
      <ListDots>
        <ListDotsWrapper>
          {mobileData.map((d, idx) => (
            <ListDotsItem key={idx}>
              {!d.last && <ListDotsProgress color={d.color}/>}
              <Dot color={d.color}>
                {getDotIcon(d.icon)}
              </Dot>
              <ListDotsItemContent>
                <ListDotsItemTitle>
                  {d.title}
                </ListDotsItemTitle>
              </ListDotsItemContent>
            </ListDotsItem>
          ))}
        </ListDotsWrapper>
        <ListDotsClear />
      </ListDots>
      <RoadmapSectionRow>
        <RoadmapSectionButtonWrapper>
          <StyledButton
            onClick={handleClick}
            variant="white-blue-text"
            type="submit"
          >
            SEE IF YOU QUALIFY
          </StyledButton>
        </RoadmapSectionButtonWrapper>
      </RoadmapSectionRow>
    </RoadmapSectionContainer>
  )
}
